/**
 * Shared constants used across the app
 */

export const DEFAULT_LOGO_URL = `${process.env.PUBLIC_URL || ''}/company-logo.svg`;
